export enum CompanyDetectionPriceList {
  Regular = 'רגיל',
  Vip = 'VIP'
}
